import {call, put, takeEvery, all, fork} from 'redux-saga/effects';

import {
    GET_PING_MONITORS,
    GET_PING_MONITOR_DETAIL,
    GET_UPTIME_CHECK_FAILURES,
    ADD_PING_MONITORS,
    EDIT_PING_MONITORS,
    MAP_ENDPOINT_TO_SERVICE,
    GET_ENDPOINT_BY_SERVICE_ID,
    GET_TIMESTAMPS,
    DELETE_ENDPOINT,
    TOGGLE_ENDPOINT,
    GET_TIMESTAMPS_BY_SERVICE_ID, VALIDATE_REGEX
} from './actionTypes';

import {
    getPingMonitorsSuccess,
    getPingMonitorsFail,
    getPingMonitorDetailSuccess,
    getPingMonitorDetailFail,
    addPingMonitorFail,
    addPingMonitorSuccess,
    editPingMonitorFail,
    editPingMonitorSuccess,
    mapEndpointToServiceFail,
    mapEndpointToServiceSuccess,
    getEndpointByServiceIdFail,
    getEndpointByServiceIdSuccess,
    getTimestampsFail,
    getTimestampsSuccess,
    deleteEndpoint,
    deleteEndpointFail,
    deleteEndpointSuccess,
    toggleEndpointFail,
    toggleEndpointSuccess,
    getTimestampsByServiceIdFail,
    getTimestampsByServiceIdSuccess,
    getUptimeCheckFailuresSuccess,
    getUptimeCheckFailuresFail,
    validateRegex,
    validateRegexSuccess,
    validateRegexFail,
    // postAddEndpointSuccess,
    // postAddEndpointFail,
    // patchEditEndpointSuccess,
    // patchEditEndpointFail
} from './actions';

import {
    getPingMonitorsUrl,
    getPingMonitorDetailUrl,
    postPingMonitorsUrl,
    patchPingMonitorsUrl,
    mapEndpointToServiceUrl,
    getEndpointByServiceIdUrl,
    getTimestampsUrl,
    getUptimeCheckFailures,
    deleteEndpointUrl,
    toggleEndpointUrl,
    getTimestampsByServiceIdUrl,
    validateRegexUrl
} from "../../helpers/fakebackend_helper";
import { showNotification } from 'components/Common/notification';

function* onGetTimestampsByServiceId({payload: application_service_id}) {
    try{
        const response = yield call(getTimestampsByServiceIdUrl, application_service_id)
        yield put(getTimestampsByServiceIdSuccess(response));
    } catch(error){
        yield put(getTimestampsByServiceIdFail(error));
    }
}

function* onGetPingMonitors(){
    try {    
        const response = yield call(getPingMonitorsUrl);
        yield put(getPingMonitorsSuccess(response));
    } catch (error) {
        yield put(getPingMonitorsFail(error));
    }
}

function* onGetPingMonitorDetail({payload: id}){
    try{
        const response = yield call(getPingMonitorDetailUrl, id);
        yield put(getPingMonitorDetailSuccess(response));
    } catch (error) {
        yield put(getPingMonitorDetailFail(error));
    }
}

function* onGetUptimeCheckFailures({payload:payload}){
    try{
        const response = yield call(getUptimeCheckFailures, payload);
        yield put(getUptimeCheckFailuresSuccess(response));
    } catch (error) {
        yield put(getUptimeCheckFailuresFail(error));
    }
}

function* onPostAddEndpoint({payload: payload}){
    try{
        const response = yield call(postPingMonitorsUrl, payload);
        yield put(addPingMonitorSuccess(response));
        if(payload.fromIntegrationFlow === true) {
            window.location.href = "/dashboard";
        }else{
            window.location.href = "/ping-monitoring";
        }
        showNotification('success', 'Successfully added endpoint');
    } catch (error) {
        yield put(addPingMonitorFail(error));
    }
}

function* onPutEditEndpoint({payload: data}){
    try{
        const response = yield call(patchPingMonitorsUrl, data);
        yield put(editPingMonitorSuccess(response))
        showNotification('success', 'Successfully updated endpoint');
        yield put({type: GET_PING_MONITORS})
    } catch (error) {
        yield put(editPingMonitorFail(error));
        showNotification('error', error)
    }
}

function* onMapEndpointToService({payload: data}) {
    try{
        const response = yield call(mapEndpointToServiceUrl, data);
        yield put(mapEndpointToServiceSuccess(response));
    } catch (error) {
        yield put(mapEndpointToServiceFail(error));
    }
}

function* onGetEndpointByServiceId({payload: data}) {
    try{
        const response = yield call(getEndpointByServiceIdUrl, data);
        yield put(getEndpointByServiceIdSuccess(response));
    } catch (error) {
        yield put(getEndpointByServiceIdFail(error));
    }
}

function* onGetTimestamps({payload: data}) {
    
    try{
        const response = yield call(getTimestampsUrl, data);
        yield put(getTimestampsSuccess(response));
    } catch(error) {
        yield put(getTimestampsFail(error))
    }
}

function* onDeleteEndpoint({payload: data}){
    try{
        const response = yield call(deleteEndpointUrl, data);
        yield put(deleteEndpointSuccess(response))
    } catch (error) {
        yield put(deleteEndpointFail(error))
    }
}

function* onToggleEndpoint({payload: data}){
    try{
        const response = yield call(toggleEndpointUrl, data)
        yield put(toggleEndpointSuccess(response))
    } catch (error) {
        yield put(toggleEndpointFail(error))
    }
}

function* onValidateRegex({payload: data}){
    try{
        const response = yield call(validateRegexUrl, data)
        yield put(validateRegexSuccess(response));
    } catch (error) {
        yield put(validateRegexFail(error));
    }
}

function* serviceSaga() {
    yield takeEvery(GET_PING_MONITORS, onGetPingMonitors);
    yield takeEvery(ADD_PING_MONITORS, onPostAddEndpoint);
    yield takeEvery(EDIT_PING_MONITORS, onPutEditEndpoint);
    yield takeEvery(GET_PING_MONITOR_DETAIL, onGetPingMonitorDetail);
    yield takeEvery(MAP_ENDPOINT_TO_SERVICE, onMapEndpointToService);
    yield takeEvery(GET_ENDPOINT_BY_SERVICE_ID, onGetEndpointByServiceId);
    yield takeEvery(GET_TIMESTAMPS, onGetTimestamps);
    yield takeEvery(DELETE_ENDPOINT, onDeleteEndpoint);
    yield takeEvery(TOGGLE_ENDPOINT, onToggleEndpoint);
    yield takeEvery(GET_TIMESTAMPS_BY_SERVICE_ID, onGetTimestampsByServiceId);
    yield takeEvery(GET_UPTIME_CHECK_FAILURES, onGetUptimeCheckFailures);
    yield takeEvery(VALIDATE_REGEX, onValidateRegex);
}

export default serviceSaga;